import React, { createContext, useContext } from 'react';

const TenantContext = createContext(null);

export const TenantProvider = ({ value, children }) => (
  <TenantContext.Provider value={value}>
    {children}
  </TenantContext.Provider>
);

export const useTenant = () => {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error('useTenant must be used within TenantProvider');
  return ctx;
};
